export enum TimeUnit {
  Seconds = "Seconds",
  Minutes = "Minutes",
  Hours = "Hours",
  Days = "Days",
}

// Constants for time unit conversions
const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_DAY = 86400;

export const translateTime = (
  fromUnit: TimeUnit,
  toUnit: TimeUnit,
  value: number,
): number => {
  console.log("fromUnit, toUnit, value", fromUnit, toUnit, value);
  let seconds: number;
  switch (fromUnit) {
    case TimeUnit.Seconds:
      seconds = value;
      break;
    case TimeUnit.Minutes:
      seconds = value * SECONDS_PER_MINUTE;
      break;
    case TimeUnit.Hours:
      seconds = value * SECONDS_PER_HOUR;
      break;
    case TimeUnit.Days:
      seconds = value * SECONDS_PER_DAY;
      break;
    default:
      throw new Error(`Unsupported time unit - 1: ${fromUnit}`);
  }
  switch (toUnit) {
    case TimeUnit.Seconds:
      return seconds;
    case TimeUnit.Minutes:
      return seconds / SECONDS_PER_MINUTE;
    case TimeUnit.Hours:
      return seconds / SECONDS_PER_HOUR;
    case TimeUnit.Days:
      return seconds / SECONDS_PER_DAY;
    default:
      throw new Error(`Unsupported time unit - 2: ${toUnit}`);
  }
};
